export enum AIEnum {
    NotChange,
    NoChoose,
    NotUsed,
    All,
    Custom,
}

export default AIEnum;
